// src/stores/counterStore.js
import { makeAutoObservable } from "mobx";

class ListeningStore {
  selectedSectionId = null;
  selectedSectionName = "";
  editMode = false;
  questionsCategory = [];
  multipleSingle=false;
  sections = [];
  uploadURL = {};
  formData = {
    title: "",
    audioFiles: [],
    questions: [],
    transcription: "",
  };

  buttonClick = false;
  buttonDisabled = true;

  constructor() {
    makeAutoObservable(this);
    this.loadPersistedData();
  }

  setButtonDisable(value) {
    this.buttonDisabled = value;
  }

  setSections(data) {
    this.sections = data;
  }
  setButtonClick(value) {
    this.buttonClick = value;
  }
  setQuestionsCategory(data) {
    this.questionsCategory = data;
  }
  setUploadURL(value) {
    this.uploadURL = value;
  }
  setEditMode(bool) {
    this.editMode = bool;
  }
  setMultipleSingle(bool){
    this.multipleSingle = bool
  }
  setFormData(newFormData) {
    this.formData = { ...this.formData, ...newFormData };
  }

  setSelectedSectionName(name) {
    this.selectedSectionName = name;
  }

  setSelectedSectionId(id) {
    this.selectedSectionId = id;
  }

  // Method to persist data to localStorage
  savePersistedData() {
    localStorage.setItem(
      "selectedSection",
      JSON.stringify({
        id: this.selectedSectionId,
        name: this.selectedSectionName,
      })
    );
  }

  // Method to load persisted data from localStorage
  loadPersistedData() {
    const persistedData = localStorage.getItem("selectedSection");
    if (persistedData) {
      const parsedData = JSON.parse(persistedData);
      this.selectedSectionId = parsedData.id;
      this.selectedSectionName = parsedData.name;
    }
  }
}

const listeningStore = new ListeningStore();
export default listeningStore;
